'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Fade = require('react-bootstrap/lib/Fade');

var _Fade2 = _interopRequireDefault(_Fade);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Fade2.default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@sketchpixy/rubix/lib/Fade.js
 ** module id = ./node_modules/@sketchpixy/rubix/lib/Fade.js
 ** module chunks = 0
 **/